import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from 'material-ui/styles';
import {
  FormLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
} from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

const styles = theme =>({
  root: {
    margin: 10,
  },
});

export class AddWhere extends Component {
  constructor(props){
    super(props);
    this.state = {
      top: true,
      bottom: false,
    };
  }

  onChange(key){
    const { onChange } = this.props;

    return function(event, checked){
      onChange(event, { [key]: checked })
    }
  }

  render(){
    const { addTo, classes } = this.props;

    return (
      <FormControl className={ classes.root } component="fieldset">
        <FormLabel component="legend">
          Please select where you want to add additional layers.
        </FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={addTo.top}
                onChange={this.onChange("top").bind(this)}
                value="Top"
              />
            }
            label="Top"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={addTo.bottom}
                onChange={this.onChange("bottom").bind(this)}
                value="Bottom"
              />
            }
            label="Bottom"
          />
        </FormGroup>
      </FormControl>
    );
  }
}

AddWhere.propTypes = {
  addTo:    PropTypes.object.isRequired,
  classes:  PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(AddWhere);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/AddLayer/AddWhere.js